import { put } from 'redux-saga/effects';
import { actionVerifyLogin, setFirebaseAuthMobileState } from 'reduxConfig/auth.creators';

export function* authVerifyLoginMobile({ email, idToken }) {
  yield put(setFirebaseAuthMobileState({ email, idToken }));
  yield put(actionVerifyLogin({ email, idToken }));
}
